import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DataService } from '../services/data/data.service';
import { VivrService } from '../services/vivr/vivr.service';
import { APP_ROUTES } from '../utils/route.constant';
import { AuthGuard } from '@auth0/auth0-angular';

export const vivrGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const dataService = inject(DataService);
    const vivrService = inject(VivrService);
    const authGuard = inject(AuthGuard);

    const sourceId = route.queryParamMap.get('sourceId');
    const accessToken = route.queryParamMap.get('access_token');

    // Check if it is a VIVR flow
    if (sourceId) {
        if (!accessToken) {
            console.error('VIVR link missing access_token');
            router.navigate([APP_ROUTES.SESSION_TIMEOUT]);
            return false;
        }

        dataService.vivrAccessToken$.next(accessToken);
        const accessTokenDataVIVR = vivrService.processAccessToken(accessToken);
        if (accessTokenDataVIVR) {
            dataService.vivrAccessTokenData$.next(accessTokenDataVIVR);
            dataService.isVivr$.next(true);
            dataService.vivrSource$.next(`${accessTokenDataVIVR?.source}-${accessTokenDataVIVR?.contractNumber}`);
            dataService.vivrSub$.next(accessTokenDataVIVR?.source || '');

            // Strip the sensitive parameters from the URL
            const urlTree = router.parseUrl(state.url);
            delete urlTree.queryParams['sourceId'];
            delete urlTree.queryParams['access_token'];
            return urlTree;
        } else {
            router.navigate([APP_ROUTES.SESSION_TIMEOUT]);
            return false;
        }
    } else if (dataService.isVivr$.getValue()) {
        // this is a scenario where SR is already in VIVR flow
        // SR Initiation from MakePayment or from MakePayment to SR confirmation
        // then we allow the navigation
        return true;
    }

    // Fallback to AuthGuard for normal flow
    return authGuard.canActivate(route, state);
};
